import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ProjectService } from 'pages/quote-setup/projects/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton, formatTableDate } from 'resources/utility';
import toastr from 'toastr';

@inject(ProjectService, DialogService, EventAggregator)
export class Projects {
    constructor(projectService, dialogService, ea) {
        this.ea = ea;
        this.projectService = projectService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'number', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'name' },
            { dataField: 'sop', caption: 'SOP', customizeText: formatTableDate },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('projects:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (project) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.projectService.delete(project.id);
                this.grid.refresh();
                toastr.success('Project was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.projectService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.projectService.editor, model: { id: data.id } });
    };
}